"use strict";

require("core-js/modules/es6.array.reduce-right");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(beforeChange) {
  return function (parcel) {
    return [].concat(beforeChange || []).reduceRight(function (parcel, updater) {
      return parcel.modifyUp(updater);
    }, parcel);
  };
};

exports["default"] = _default;